export function getVisibleNumberOfItems<ItemType extends object>(
    containerWidth: number,
    items: ItemType[],
    getStringWidth: (item: ItemType) => number
): number {
    let widthAccumulator = 0;
    for (let i = 0; i < items.length; i++) {
        widthAccumulator += getStringWidth(items[i]);
        if (widthAccumulator >= containerWidth) {
            return i;
        }
    }
    return items.length;
}
